import * as React from 'react';
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import Sheet from '@mui/joy/Sheet';
import {useEffect} from "react";
import { Transition } from 'react-transition-group';

const InfoModal = () => {
    const [open, setOpen] = React.useState(false);

    const openModal = ()=> {
        setTimeout(()=>{
            setOpen(true);
        }, 3000);
    }

    useEffect(openModal,[])

    return (
        <React.Fragment>
            <Transition in={open} timeout={400}>

            {(state) => (
            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center',  visibility: state === 'exited' ? 'hidden' : 'visible', }}
                keepMounted
                open={!['exited', 'exiting'].includes(state)}
                onClose={() => setOpen(false)}
                slotProps={{
                    backdrop: {
                        sx: {
                            opacity: 0,
                            backdropFilter: 'none',
                            transition: `opacity 400ms, backdrop-filter 400ms`,
                            ...{
                                entering: { opacity: 1, backdropFilter: 'blur(8px)' },
                                entered: { opacity: 1, backdropFilter: 'blur(8px)' },
                            }[state],
                        },
                    },
                }}
            >
                <Sheet
                    sx={{
                        width: '90%',
                        height: 175,
                        paddingLeft: 1,
                        paddingRight: 1,
                        paddingTop: 3,
                        paddingBottom: 3,
                        borderRadius: 'md',
                        opacity: 0,
                        transition: `opacity 300ms`,
                        ...{
                            entering: { opacity: 1 },
                            entered: { opacity: 1 },
                        }[state],
                    }}
                >
                    <ModalClose variant="outlined" />
                    <p className={'modal-text'}
                        id="close-modal-title"
                    >
                        Դասընթացի մեկնարկը՝
                    </p>
                    <p className={'modal-body-text'}
                       id="close-modal-title"
                    >
                        Մարտի 20-ից
                    </p>

                </Sheet>
            </Modal>
            )}
        </Transition>
        </React.Fragment>
    );
}
export default InfoModal;
